import { render } from "./CrudModal.vue?vue&type=template&id=836c7b0e&scoped=true"
import script from "./CrudModal.vue?vue&type=script&lang=js"
export * from "./CrudModal.vue?vue&type=script&lang=js"

import "./CrudModal.vue?vue&type=style&index=0&id=836c7b0e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-836c7b0e"]])

export default __exports__